import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'app/service/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _toastService: NotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // 401 is handled by JwtInterceptor (session expiry -> redirect to login),
        // don't also toast it here
        if (err.status !== 401) {
          this._toastService?.showError?.(err.message || err.statusText, '');
        }
        return throwError(() => err);
      })
    );
  }
}

